// File#: _1_vertical-timeline
// Usage: codyhouse.co/license
(function () {
  var VTimeline = function (element) {
    this.element = element;
    this.sections = this.element.getElementsByClassName("js-timeline__section");
    this.animate =
      this.element.getAttribute("data-animation") &&
      this.element.getAttribute("data-animation") == "on"
        ? true
        : false;
    this.animationClass = "timeline__section--animate";
    this.animationDelta = "-150px";
    initVTimeline(this);
  };

  function initVTimeline(element) {
    if (!element.animate) return;
    for (var i = 0; i < element.sections.length; i++) {
      var observer = new IntersectionObserver(
        vTimelineCallback.bind(element, i),
        { rootMargin: "0px 0px " + element.animationDelta + " 0px" }
      );
      observer.observe(element.sections[i]);
    }
  }

  function vTimelineCallback(index, entries, observer) {
    if (entries[0].isIntersecting) {
      Util.addClass(this.sections[index], this.animationClass);
      observer.unobserve(this.sections[index]);
    }
  }

  //initialize the VTimeline objects
  var timelines = document.querySelectorAll(".js-timeline"),
    intersectionObserverSupported =
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype,
    reducedMotion = Util.osHasReducedMotion();
  if (timelines.length > 0) {
    for (var i = 0; i < timelines.length; i++) {
      if (intersectionObserverSupported && !reducedMotion)
        (function (i) {
          new VTimeline(timelines[i]);
        })(i);
      else timelines[i].removeAttribute("data-animation");
    }
  }
})();
